// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4d34a6b1","93":"ebe90b74","282":"4a2e9e20","505":"0a40b649","652":"335da058","672":"07dbacdf","682":"bde12524","869":"a818adef","877":"064625b6","986":"458b8ecb"}[chunkId] + ".chunk.js";
};